import React from 'react';
import './loading.scss';

export default function LoadingIcon() {
  return <div className="loading-icon">&nbsp;</div>;
}
